import styled, { css } from 'styled-components'
import { DropdownMenu } from 'sutra/components'
import { shadows } from 'sutra/tokens/shadows'

/*
 * Heavier border + shadow than the DropdownMenu default; scoped to this menu's
 * popup by styling the wrapper, not a global selector.
 */
export const AgentRowKebabMenu = styled(DropdownMenu)`
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: ${shadows.lg};
`

/*
 * Color the icon slot (not the menu item) so MUI's fill-based icons and
 * our stroke-based SVGs both render at the same tint via `currentColor`.
 */
export const MenuItemIcon = styled.span<{ $danger?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  color: ${({ $danger }) => ($danger ? '#D92D20' : '#A4A7AE')};
  svg {
    width: 20px;
    height: 20px;
  }
`

export const MenuItemLabel = styled.span<{ $danger?: boolean }>`
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  ${({ $danger }) =>
    $danger
      ? css`
          color: #d92d20;
        `
      : css`
          color: #28364f;
        `}
`
